// extracted by mini-css-extract-plugin
export default {"container":"navigation_container__xMXHM","active_link":"navigation_active_link__ElXHP"};